import { GenericResponse } from '../types';
import { getHeaders, tosApi } from './tosApi';

export type DockingWasteCollectionItemType = {
  docking_id: number;
  docking_code: string | null;
  vessel_name: string | null;
  vessel_flag: string | null;
  docking_place_name: string | null;
  last_cable_untied_in: string | null;
  has_waste_collection: boolean | null;
  sent_has_waste_collection: boolean | null;
  last_date_xml: string | null;
};

export type DockingWasteCollectionStatusType = 'PENDING' | 'YES' | 'NO';

export type DockingWasteCollectionParamsType = {
  code_or_vessel__name?: string;
  initial_date_report?: string | null;
  final_date_report?: string | null;
  waste_collection_status?: DockingWasteCollectionStatusType;
  page?: number;
  page_size?: number;
};

export type UpdateDockingWasteCollectionPayload = {
  docking_id: number;
  has_waste_collection: boolean;
};

export type UpdateDockingsWasteCollectionPayload = {
  docking_ids: number[];
  has_waste_collection: boolean;
};

export type FillPendingDockingsWasteCollectionPayload = {
  has_waste_collection: boolean;
  initial_date_report: string;
  final_date_report: string;
  code_or_vessel__name?: string;
};

export type WasteCollectionBatchResponseType = {
  updated: number;
};

export const wasteCollectionApi = tosApi.injectEndpoints({
  endpoints: (build) => ({
    getDockingsWasteCollection: build.query<
      GenericResponse & { results: DockingWasteCollectionItemType[] },
      DockingWasteCollectionParamsType | void
    >({
      query: (params) => ({
        url: '/maritime/dockings/waste-collection',
        method: 'GET',
        headers: getHeaders,
        params: params || {},
      }),
      providesTags: () => [{ type: 'WasteCollection', id: 'LIST' }],
    }),
    updateDockingWasteCollection: build.mutation<
      void,
      UpdateDockingWasteCollectionPayload
    >({
      query: ({ docking_id, has_waste_collection }) => ({
        url: `/maritime/dockings/${docking_id}/waste-collection`,
        method: 'PATCH',
        body: { has_waste_collection },
      }),
      invalidatesTags: [{ type: 'WasteCollection', id: 'LIST' }],
    }),
    updateDockingsWasteCollection: build.mutation<
      WasteCollectionBatchResponseType,
      UpdateDockingsWasteCollectionPayload
    >({
      query: (payload) => ({
        url: '/maritime/dockings/waste-collection',
        method: 'PATCH',
        body: payload,
      }),
      invalidatesTags: [{ type: 'WasteCollection', id: 'LIST' }],
    }),
    fillPendingDockingsWasteCollection: build.mutation<
      WasteCollectionBatchResponseType,
      FillPendingDockingsWasteCollectionPayload
    >({
      query: (payload) => ({
        url: '/maritime/dockings/waste-collection/pending',
        method: 'PATCH',
        body: payload,
      }),
      invalidatesTags: [{ type: 'WasteCollection', id: 'LIST' }],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetDockingsWasteCollectionQuery,
  useLazyGetDockingsWasteCollectionQuery,
  useUpdateDockingWasteCollectionMutation,
  useUpdateDockingsWasteCollectionMutation,
  useFillPendingDockingsWasteCollectionMutation,
} = wasteCollectionApi;
